<template>
    <div class='index'>
        <div class="content">
            <h4>在线隐私保护政策</h4>
            <pre class="precla">
提示条款:

您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，快康信息科技有限公司作为服务提供者（或简称“我们”）制定本《隐私权政策》（下称“本政策”）并提醒您：

本政策不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您说明的隐私权政策。

在使用快康信息科技有限公司各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后再开始使用。如对本政策内容有任何疑问、意见或建议，您可以随时要求我们的客服人员进行解答，官方客服电话为：18961886679。

 第一部分 定义

服务提供者：指无锡快康信息科技有限公司，地址：江苏省无锡市梁清路815号。
个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。

个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息信息等的个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体字进行显著标识）。

个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。

第二部分 隐私权政策

我们很乐意为您提供服务。本政策将帮助您了解以下内容：

一、 适用范围

用户在注册及使用平台服务过程中，为享受该等服务根据平台要求提供的个人信息；

在您使用平台服务、参加平台活动、或访客户端时，平台自动接收并记录的您的服务器数据，包括但不限于IP地址、客户端Cookie中的资料及您要求取用的记录；

平台通过合法途径取得的用户其他个人资料。

二、信息使用

我们平台不会向任何人出售或出借您的个人信息，除非事先得到您的许可。

为服务用户的目的，我们平台可通过使用您的个人信息，向您提供服务，包括但不限于向您发出平台通知、互动信息等。

我们平台保证不对外公开或向第三方提供用户的个人注册资料及用户在使用平台服务时存储的非公开内容，但下列情况除外：根据有关的法律法规要求或按照相关政府主管部门的要求。

尊重用户个人隐私信息的私有性是本平台的一贯原则，本平台将通过技术手段、强化内部管理等办法充分保护用户的个人隐私信息。为了运营和改善本平台的技术与服务，本平台将可能会自行收集使用或向第三方提供用户的非个人隐私信息，这将有助于本平台向用户提供更好的用户体验和服务质量。“例如，当您使用本产品集成的小米推送服务时，小米将作为数据处理者，按照本公司的指示收集处理您的数据，小米将按照隐私政策保护用户的隐私数据，

您使用或继续使用我们的服务，即意味着同意我们按照本条约定收集、使用、储存和分享您的相关信息。

三、信息授权

您授权本平台在仅透露非用户个人隐私信息的前提下，除法律另有规定之外，将您提供给本平台的信息（包括本协议签署之前提供和产生的信息）、享受本平台服务产生的信息以及本平台根据本第七条约定查询、收集的信息，用于本平台及其因服务必要委托的合作伙伴为向您及其他用户提供服务、开展市场调查与信息数据分析之目的。在遵守上述所有规定的前提下，本平台有权对整个用户信息数据库进行分析并对用户信息数据库进行商业上的利用。

受限于上述约定，基于提供更优质服务的目的，您授权本平台，除法律另有规定之外，向本平台因服务必要开展合作的伙伴提供、查询和收集您的信息。

如您不同意上述授权条款的部分或全部，应停止使用本平台。

我们如何收集和使用您的信息

在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：

为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；

为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。

您理解并同意：

为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随着我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过本平台提供的各种联系方式与我们联系，我们会尽快为您作出解答。

我们会基于本政策所述的以下目的，收集和使用您的个人信息：

（一）注册账号

基础账号服务：为完成创建账号，您需提供以下信息：您创建的账户名、密码和手机号码，可选择性提供微信帐号标识信息（如UnionID、OpneID、头像、昵称、性别、关联手机号等个人信息。

（二）实名认证与申请物料

在出现以下情形时我们将会收集您的实名信息：（1）您在注册我们平台时进行身份认证时，我们手机的实名信息可能包括姓名、性别、所属医院、科室、职称，以及医生的资质证件信息：医师资格证书、医师执业证书、专业资格证书、身份证，您可以选择是否进行实名认证；（2）您在我们平台要添加收款账户时，需要您进行实名认证。我们收集的实名信息可能包括真实姓名、身份证件信息（身份证、护照、港澳通行证、台胞证的号码）及您授权的人脸信息。 为了保证信息的真实性和唯一性，我们会基于您所提供的信息通过征信平台或其他惯常方式进行实名验证，实名认证成功后您所提供的实名信息将不可修改；③您在我们平台申请邮寄物料时，我们收集的信息可能包括：收件人姓名、收件人手机号、收件人地址信息。

（三）商品或服务信息展示

在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息，包括：

设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、设备广告标识符、移动设备识别码、网卡地址、移动应用列表等软硬件及设备环境信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）。

服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。

请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。

为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和服务日志信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息和可能的商业广告。  

 此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。

五、如何管理您的信息

（一）访问、更正或补充您的个人信息

账户信息：如果您希望访问或编辑您的账户中的个人基本资料信息，在小程序端，您可以通过登陆账号在“我”中执行此操作。

更改绑定手机：如果您希望更改您的账户中的绑定手机，在小程序端，您可以通过登陆账号在“我-编辑个人资料”中执行此操作。

收款账户：如果您想修改收款账户信息，在小程序端，您可以通过登陆账号在“我-我的账单”中执行此操作。

（二）删除您的个人信息

在以下情形中，您可以向我们提出删除个人信息的请求：

如果我们处理个人信息的行为违反法律法规或约定；

如果我们收集、使用您的个人信息，却未征得您的同意；

如果您不再使用我们的产品或服务，或您注销了账号；

若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体已获得您的独立授权。

当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。

共享您的个人信息
我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：

1.事先获得您的明确授权或同意： 获得您的明确同意后，我们会与其他方共享您的个人信息；

2.在法定情形下的共享： 根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；

3.在法律要求或允许的范围内，为了保护本及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；

4.与我们的关联公司共享： 您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享受本政策所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；

5.与授权合作伙伴共享： 为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。本向您寄送物料时，需要与合作制作商以及物流服务提供商共享您的个人信息才能安排寄送。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理您的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。 如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在本中使用该第三方服务。

目前，我们的授权合作伙伴包括以下类型：

分析服务类的授权合作伙伴。 除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，包含姓名、手机号或身份证信息）与提供分析服务的合作伙伴分享。对于分析数据的伙伴，为了更好的分析本用户的使用情况，我们可能向其提供本用户的数量、地区分布、活跃情况数据，但我们仅会向这些合作伙伴提供不能识别个人身份的统计信息（例如「位于广州的 23 岁男性医生」）；
供应商、服务提供商和其他合作伙伴。 我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴共享（包含向我们和您提供在线挂号服务的挂号服务供应商，代表我们发出短信的通讯服务供应商，以及为我们和您提供协助的地图服务供应商分享位置数据，向提供药品的服务供应商提供姓名、电话、地址），这些信息的用途受到如下限制：

协助我们向您提供服务；

履行我们根据本政策的责任和实现我们的权利，及协助理解和改善本提供的服务；

提供技术基础设施服务、分析我们的服务、衡量服务的有效性、支付或进行学术研究和调查。

 （三）申请注销账户

您可以通过本官方客服电话：18961886679或联系 “在线客服”申请注销账户。在您主动注销账户之后，我们将停止为您提供服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。但如您尚有订单未完成或有其他可能影响您咨询权益的其他例外情形，我们需待上述情形消失后予以注销。

您可以通过更正、删除、注销的方式来收回您授权同意我们使用的个人信息，当您收回授权同意后，我们将不再以相应的方式处理您相应的个人信息。但您收回授权同意的决定，不会影响此前我们基于您的授权同意而开展的对您个人信息所进行的处理。

（四）响应您的上述请求

为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。

我们将在15天内做出答复。如您不满意，还可以通过本客服发起投诉。

对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。

在以下情形中，按照法律法规要求，我们将无法响应您的请求：

与国家安全、国防安全有关的；

与公共安全、公共卫生、重大公共利益有关的；

与犯罪侦查、起诉、审判和执行判决等有关的；

有充分证据表明个人信息主体存在主观恶意或滥用权利的；

响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；

涉及商业秘密的。

六、本隐私权政策如何更新

随着法律法规的出台或修订，我们的《隐私权政策》可能会发生变更。未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。

对隐私权政策所做的任何变更我们将会提供显著的通知（包括通过站内推送、页面标注等方式进行通知）。

本政策所指的重大变更包括但不限于：

我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；

我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；

个人信息共享、转让或公开披露的主要对象发生变化；

您参与个人信息处理方面的权利及其行使方式发生重大变化；

我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；

个人信息安全影响评估报告表明存在高风险。

七、联系我们及其他

如您对本《隐私权政策》内容有任何疑问、意见或建议， 您可以通过以下方式与我们联系，我们将在15天内回复您的请求：

如对本政策内容、个人信息有任何疑问、意见或建议，您可通过本客服与我们联系，官方客服电话为：18961886679，同时您也可以联系我们的“在线客服”；

				</pre>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        watch: {},
        computed: {},
        created() {},
        mounted() {},
        methods: {},
    };
</script>
<style lang="scss" scoped>
    .index {
        .content {
            background-color: #fff;
            padding:  20px;
            overflow: hidden;

            h4 {
                text-align: center;
                font-size: 25px;
            }

            .precla {
                white-space: pre-line;
                line-height: 20px;
                color: #333;
            }
        }
    }
</style>